/**
 * Display label for a coverage / plan type as shown in coverage tabs and
 * summaries (Benefits & Plans enrollments, prospect enrollments, employee
 * summary). Special-cases the acronym/branded types so "add" renders as
 * "AD&D" (not "Add", which reads like the verb), STD/LTD stay uppercase, and
 * FSA types get full names. Anything else falls back to Title Case.
 *
 * Kept separate from TYPE_META (shared/schemas/planTypes.ts) on purpose: this
 * matches the tab vocabulary (e.g. "Health", not TYPE_META's "Medical").
 */
const SPECIAL_LABELS: Record<string, string> = {
  add: "AD&D",
  std: "STD",
  ltd: "LTD",
  fsa_health: "Health Care FSA",
  fsa_dependent_care: "Dependent Care FSA",
  transit: "Transit",
};

export function coverageTypeLabel(type: string | null | undefined): string {
  const key = (type ?? "").toString().trim().toLowerCase();
  if (!key) return "";
  if (SPECIAL_LABELS[key]) return SPECIAL_LABELS[key];
  return key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}
